import PdfViewer from "Components/PdfViewer";
import croPdf from "../pdfs/cro/diningEtiquette.pdf";
import enPdf from "../pdfs/en/diningEtiquette.pdf";
import Navbar from "Components/Navbar";
import { LANGUAGES } from "util/useTranslate";
import ParallaxBackground from "Components/ParallaxBackground";

const DiningEtiquette = () => {
  return (
    <>
      <Navbar />
      <PdfViewer
        files={{
          [LANGUAGES.CRO]: croPdf,
          [LANGUAGES.EN]: enPdf,
        }}
      />
    <ParallaxBackground src={"/backgrounds/kapulica.png"} position={"bottom right"} size={"50vh"} />
    </>
  );
};

export default DiningEtiquette;
